export enum CONNECTION_STATUS {
  CONNECTED = 'connected',
  DISCONNECTED = 'disconnected',
  WARNING = 'warning',
  PROCESSING = 'processing',
}
